<template>
    <LoginBoxCard>
      <template v-slot:text>
        <AlertError :error-message="errorMessage"/>
        <AlertSuccess message="You have selected a role"/>
        <p>You have selected the role: {{ role }}</p>
      </template>
    </LoginBoxCard>
</template>

<script>
/**
 * Informational card diplayed when a user has successfully assumed a role
 */
import LoginBoxCard from '@/components/regular/LoginBoxCard'
import AlertSuccess from '@/components/regular/AlertSuccess'
import AlertError from '@/components/regular/AlertError'
export default {
  name: 'RoleSelectedMessage',
  components: { AlertSuccess, LoginBoxCard, AlertError },
  props: {
    role: {
      type: String
    },
    errorMessage: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>
